"use client";
import { jsx as a } from "react/jsx-runtime";
import * as r from "@radix-ui/react-tabs";
import { cva as m } from "class-variance-authority";
import { useContext as p, isValidElement as f, createContext as g } from "react";
import { cn as o } from "../../../utils/utils.mjs";
import { Text as v } from "../Text/Text.mjs";
import { getAccessibleFocusStyles as x } from "../../../utils/styles.mjs";
const n = g({}), h = m(
  `data-[state=active]:bg-gray-800 data-[state=active]:text-white data-[state=active]:font-semibold
    inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-3 border border-transparent px-4 py-3 border-none whitespace-nowrap
    focus-visible:border-ring focus-visible:ring-ring/50
    ${x()}
    disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
  {
    variants: {
      shape: {
        square: "rounded-sm data-[state=active]:rounded-sm",
        rounded: "rounded-md data-[state=active]:rounded-capsule"
      },
      outline: {
        true: "data-[state=active]:border data-[state=active]:border-solid data-[state=active]:border-gray-500",
        false: ""
      }
    },
    defaultVariants: {
      shape: "rounded",
      outline: !1
    }
  }
), V = ({ className: t, shape: e, outline: s, ...i }) => /* @__PURE__ */ a(n.Provider, { value: { shape: e, outline: s }, children: /* @__PURE__ */ a(r.Root, { "data-slot": "tabs", className: o("flex flex-col gap-2", t), ...i }) }), _ = ({ className: t, ...e }) => /* @__PURE__ */ a(
  r.List,
  {
    "data-slot": "tabs-list",
    className: o("inline-flex h-13 w-fit items-center justify-center", t),
    ...e
  }
), z = ({
  className: t,
  asChild: e,
  children: s,
  fontSize: i = "base",
  fontWeight: c = "regular",
  fontFamily: d = "inter",
  ...l
}) => {
  const { shape: u, outline: b } = p(n);
  return /* @__PURE__ */ a(
    r.Trigger,
    {
      asChild: e,
      "data-slot": "tabs-trigger",
      className: o(h({ shape: u, outline: b }), t),
      ...l,
      children: /* @__PURE__ */ a(v, { asChild: !0, fontSize: i, fontWeight: c, fontFamily: d, children: f(s) ? s : /* @__PURE__ */ a("span", { children: s }) })
    }
  );
}, L = ({ className: t, ...e }) => /* @__PURE__ */ a(r.Content, { "data-slot": "tabs-content", className: o("flex-1 outline-none", t), ...e });
export {
  L as TabsContent,
  _ as TabsList,
  V as TabsRoot,
  z as TabsTrigger
};
